<template>
  <el-input ref='input'
            v-model='val'
            :size='size'
            :style='cssStyle'
            :type="type"
            :rows="rows"
            :disabled='disabled'
            :readonly="readonly"
            :clearable='clearable'
            :placeholder='placeholder'
            @focus='$refs.input.select()'
            @change="$emit('change', $event)">
  </el-input>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    size: {
      default: "mini"
    },
    cssStyle: {
      default: "width: 100%"
    },
    type: {
      default: 'text'
    },
    clearable: {
      default: true
    },
    rows: {
      default: 5
    },
    placeholder: String,
    value: String,
    disabled: {
      default: false
    },
    readonly: {
      default: false
    },
  },
  data() {
    return {
      val: this.value || ''
    }
  },
  watch: {
    value: function(value) {
      this.val = value;
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cx/cxInput.vue